import { useAuth0 } from '@auth0/auth0-react';
import SaveIcon from '@mui/icons-material/Save';
import LoadingButton from '@mui/lab/LoadingButton';
import {
    Box,
    Grid,
    LinearProgress,
    Modal,
    styled,
    TextField,
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Prompt } from 'react-router';
import theme from '../../muiTheme';
import { removeAvailability } from '../../redux/AvailabilitySlice';
import { updateProfile } from '../../redux/ProfileSlice';
import InputImageModal from '../BasicComponents/InputImageModal';
import LimitedTextField from '../BasicComponents/LimitedTextField';
import MobileEntry from '../BasicComponents/MobileEntry';
import LocationSearchInput from '../GoogleAutoComplete';

const Image = styled('img')(({ theme }) => ({
    borderRadius: '15px',
    boxShadow: '0 0 25px 0 #b3bac7',
    width: 150,
    height: 150,
    margin: 'auto',
}));

const GeneralText = styled(TextField)(({ theme }) => ({
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginLeft: '0.5%',
    marginRight: '0.5%',
    width: '97%',
}));

const BookingButton = styled(LoadingButton)(({ theme }) => ({
    padding: '10px 0px',
    margin: '10px auto',
    width: '100%',
    maxWidth: '150px',
    borderRadius: '30px',
}));

export const General = props => {
    const { getAccessTokenSilently } = useAuth0();

    const dispatch = useDispatch();

    const firstNameLocation = useRef(null);
    const lastNameLocation = useRef(null);
    const phoneLocation = useRef(null);
    const addressLocation = useRef(null);

    // profileImg Modal; default closed
    const [open, setOpen] = React.useState(false);
    const [loading, setLoading] = useState(false);

    const [saveDisabled, setSaveDisabled] = useState(false);

    function titleCase(str) {
        str = str.toLowerCase();
        return str.replace(/(^|\W)[a-z]/g, letter => {
            return letter.toUpperCase();
        });
    }

    const [state, setState] = useState({
        firstName: {
            value: titleCase(props.profile.firstName),
            touched: false,
            error: false,
            errorCode: '',
        },
        lastName: {
            value: titleCase(props.profile.lastName),
            touched: false,
            error: false,
            errorCode: '',
        },
        dateOfBirth: {
            value: props.profile.dateOfBirth,
            touched: false,
            error: false,
            errorCode: '',
        },
        address: {
            value: {
                address: props.profile.address,
            },
            touched: false,
            error: false,
            errorCode: '',
        },
        phoneNumber: {
            value: props.profile.phoneNumber,
            touched: false,
            error: false,
            errorCode: '',
        },
        apiMessage: '',
        bio: {
            value: props.profile.bio,
            touched: false,
            error: false,
            errorCode: '',
        },
        imageURL: {
            value: props.profile.profileImage,
            touched: false,
            error: false,
            errorCode: '',
        },
        submitError: false,
        email: '',
        ackronym: '',
        loadingImage: false,
    });

    useEffect(() => {
        setSaveDisabled(
            !(
                state.phoneNumber.touched ||
                state.firstName.touched ||
                state.lastName.touched ||
                state.imageURL.touched ||
                state.bio.touched ||
                state.address.touched
            ) ||
                state.phoneNumber.error ||
                state.firstName.error ||
                state.lastName.error ||
                state.imageURL.error ||
                state.bio.error ||
                state.address.error
        );
    }, [state]);

    const updateField = event => {
        const { id, value } = event.target;
        var itemStruct = {
            value: value,
            touched: true,
            error: state.error,
            errorCode: state.errorCode,
        };
        setState({
            ...state,
            [id]: itemStruct,
        });
    };

    const exitField = event => {
        const { id, value } = event.target;
        // save field values
        const doNothing = value;
        console.log(doNothing);
        var itemStruct = {
            value: state[id].value,
            touched: true,
            error: false,
            errorCode: '',
        };
        if (
            state[id].value.match(/\w/) === null ||
            state[id].value.match(/[<>]/)
        ) {
            itemStruct.error = true;
            itemStruct.errorCode = 'Please input your ' + id;
        }
        console.log(event.target);
        setState({
            ...state,
            [id]: itemStruct,
        });
    };

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const changingAddress = value => {
        let addressObj = state.address;
        addressObj.value = { address: value };
        addressObj.touched = true;
        setState({
            ...state,
            address: addressObj,
        });
    };

    const handleSelect = addressResult => {
        let addressObject = state.address;
        addressObject.value = {
            address: addressResult.address,
            LatLng: addressResult.LatLng,
        };
        addressObject.touched = true;
        addressObject.error = false;
        setState({
            ...state,
            address: addressObject,
        });
    };

    function phoneError(value) {
        var interimState = state.phoneNumber;
        interimState.error = value;
        setState({
            ...state,
            phoneNumber: interimState,
        });
    }

    function phoneValue(value) {
        var interimState = state.phoneNumber;
        interimState.value = value;
        setState({
            ...state,
            phoneNumber: interimState,
        });
    }

    function phoneTouched(value) {
        var interimState = state.phoneNumber;
        interimState.touched = value;
        setState({
            ...state,
            phoneNumber: interimState,
        });
    }

    const updateUserProfile = async () => {
        function resetTouchedItems() {
            let imageURL = state.imageURL;
            let firstName = state.firstName;
            let lastName = state.lastName;
            let address = state.address;
            let phoneNumber = state.phoneNumber;
            let bio = state.bio;
            imageURL.touched = false;
            firstName.touched = false;
            lastName.touched = false;
            address.touched = false;
            bio.touched = false;
            phoneNumber.touched = false;
            setState({
                ...state,
                profileImage: imageURL,
                firstName: firstName,
                lastName: lastName,
                address: address,
                bio: bio,
                phoneNumber: phoneNumber,
            });
        }

        try {
            setLoading(true);
            async function update() {
                const token = await getAccessTokenSilently({
                    scope: process.env.REACT_APP_scope,
                });
                //Add Code here to dynamically build request with items that have been touched
                var updateList = [];
                if (state.firstName.touched === true) {
                    updateList.push({
                        'key': 'firstName',
                        'value': state.firstName.value,
                    });
                }
                if (state.lastName.touched === true) {
                    updateList.push({
                        'key': 'lastName',
                        'value': state.lastName.value,
                    });
                }
                if (state.phoneNumber.touched === true) {
                    updateList.push({
                        'key': 'phoneNumber',
                        'value': state.phoneNumber.value
                            .replace(/\s/g, '')
                            .replace('+61', '0'),
                    });
                }
                if (state.imageURL.touched === true) {
                    updateList.push({
                        'key': 'profileImage',
                        'value': state.imageURL.value,
                    });
                }
                if (state.bio.touched === true) {
                    updateList.push({ 'key': 'bio', 'value': state.bio.value });
                }
                if (state.address.touched === true) {
                    updateList.push({
                        'key': 'address',
                        'value': state.address.value.address,
                    });
                    updateList.push({
                        'key': 'lat',
                        'value': state.address.value.LatLng.lat.toString(),
                    });
                    updateList.push({
                        'key': 'lng',
                        'value': state.address.value.LatLng.lng.toString(),
                    });
                }
                let dynamoData = {
                    token: token,
                    request: {
                        'updateList': updateList,
                    },
                };
                const generalResponse = await dispatch(
                    updateProfile(dynamoData)
                );
                console.log(
                    'general response',
                    JSON.stringify(generalResponse)
                );
                if (typeof generalResponse.payload !== 'undefined') {
                    if (generalResponse.payload.status === 200) {
                        console.log(
                            'avails',
                            generalResponse.payload.data.Message.avails
                        );
                        if (
                            typeof generalResponse.payload.data.Message
                                .avails !== 'undefined'
                        ) {
                            dispatch(removeAvailability('Remove'));
                        }

                        // props.setSnackBar(
                        //     true,
                        //     'success',
                        //     'Profile information updated'
                        // );
                        props.setNotif(
                            'success',
                            6000,
                            'Profile information updated'
                        );
                        resetTouchedItems();
                    } else {
                        // props.setSnackBar(
                        //     true,
                        //     'error',
                        //     'Error updating your profile information'
                        // );
                        props.setNotif(
                            'error',
                            0,
                            'Error updating your profile information'
                        );
                    }
                } else {
                    props.setNotif(
                        'error',
                        0,
                        'Error updating your profile information'
                    );
                    // props.setSnackBar(
                    //     true,
                    //     'error',
                    //     'Error updating your profile information'
                    // );
                }
                setLoading(false);
            }
            update();
        } catch (err) {
            console.log('Error occurred updating profile');
            setState({
                ...state,
                apiMessage: 'Error occurred updating profile',
            });
            setLoading(false);
        }
    };

    function findError() {
        console.log('starting to look for errors');
        var addressError = { error: false, errorText: '' };
        var firstNameError = { error: false, errorText: '' };
        var lastNameError = { error: false, errorText: '' };
        var dateError = { error: false, errorText: '' };
        if (
            typeof state.address.value.LatLng === 'undefined' &&
            state.address.touched === true
        ) {
            addressError.error = true;
            addressError.errorText = 'Enter your address';
        }
        if (state.firstName.value === '' && state.firstName.touched === true) {
            firstNameError.error = true;
            firstNameError.errorText = 'Enter your first name';
        }
        if (state.lastName.value === '' && state.lastName.touched === true) {
            lastNameError.error = true;
            lastNameError.errorText = 'Enter your last name';
        }
        if (
            state.dateOfBirth.value === '' &&
            state.dateOfBirth.touched === true
        ) {
            dateError.error = true;
            dateError.errorText = 'Enter your birthday';
        }
        if (firstNameError.error) {
            firstNameLocation.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest',
            });
        } else if (lastNameError.error) {
            lastNameLocation.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest',
            });
        } else if (phoneError.error) {
            phoneLocation.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest',
            });
        } else if (addressError.error) {
            addressLocation.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest',
            });
        }

        setState({
            ...state,
            address: {
                value: { address: state.address.value.address },
                touched: false,
                error: addressError.error,
                errorCode: addressError.errorText,
            },
            dateOfBirth: {
                value: state.dateOfBirth.value,
                touched: false,
                error: dateError.error,
                errorCode: dateError.errorText,
            },
            firstName: {
                value: state.firstName.value,
                touched: false,
                error: firstNameError.error,
                errorCode: firstNameError.errorText,
            },
            lastName: {
                value: state.lastName.value,
                touched: false,
                error: lastNameError.error,
                errorCode: lastNameError.errorText,
            },
        });
    }

    function handleProfileSubmit(event) {
        console.log('event.target: ' + JSON.stringify(event.target.id));
        event.preventDefault();
        if (
            state.firstName.value === '' ||
            state.lastName.value === '' ||
            (typeof state.address.value.LatLng === 'undefined' &&
                state.address.touched === true) ||
            state.dateOfBirth.value === '' ||
            state.phoneNumber.value === '' ||
            state.phoneNumber.error === true
        ) {
            findError();
        } else {
            updateUserProfile();
        }
    }

    // function imageExists(url, callback) {
    //     console.log(url);
    //     var img = new Image();
    //     img.onload = function () {
    //         callback(true);
    //     };
    //     img.onerror = function () {
    //         callback(false);
    //     };
    //     img.src = url;
    // }

    let callback = imageURL => {
        console.log('imageURL', imageURL);
        var itemStruct = {
            value: imageURL,
            touched: true,
            error: false,
            errorCode: '',
        };
        setState({
            ...state,
            loadingImage: true,
        });
        setTimeout(() => {
            // check if image exists first
            // imageExists(imageURL, function (exists) {
            //     if (exists) {
            //         // then set state
            //         setState({
            //             ...state,
            //             imageURL: itemStruct,
            //         });
            //     } else {
            //         props.setSnackBar(true, 'error', 'Image URL Not Found');
            //     }
            // });
            setState({
                ...state,
                imageURL: itemStruct,
                loadingImage: false,
            });
        }, 2000);
        handleClose();
    };

    return (
        <Grid container xs={12}>
            <Prompt
                when={
                    state.firstName.touched === true ||
                    state.lastName.touched === true ||
                    state.address.touched === true ||
                    state.bio.touched === true ||
                    state.phoneNumber.touched === true ||
                    state.imageURL.touched === true
                }
                message="There are unsaved changes. Are you sure you want to leave?"
            />
            <Grid
                item
                md="150px"
                sx={{
                    padding: '0 20px 0 0',
                }}
            >
                <Image
                    src={state.imageURL.value}
                    onClick={handleOpen}
                    alt="Profile Picture"
                />
                {state.loadingImage && <LinearProgress sx={{ m: 1 }} />}
            </Grid>
            <Grid
                item
                md
                sx={{
                    margin: 'auto',
                    width: '100%',
                }}
            >
                <GeneralText
                    disabled
                    id="email"
                    data-cy="email"
                    label="Email"
                    variant="outlined"
                    value={props.profile.email}
                />
                <GeneralText
                    ref={firstNameLocation}
                    error={state.firstName.error}
                    id="firstName"
                    data-cy="first-name"
                    label="First Name"
                    variant="outlined"
                    helperText={state.firstName.errorCode}
                    value={state.firstName.value}
                    onChange={updateField}
                    onBlur={exitField}
                />

                <GeneralText
                    ref={lastNameLocation}
                    error={state.lastName.error}
                    id="lastName"
                    data-cy="last-name"
                    label="Last Name"
                    variant="outlined"
                    helperText={state.lastName.errorCode}
                    value={state.lastName.value}
                    onChange={updateField}
                    onBlur={exitField}
                />

                <GeneralText
                    disabled
                    id="dateOfBirth"
                    data-cy="date-of-birth"
                    label="Date of Birth"
                    type="date"
                    value={state.dateOfBirth.value}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />

                <MobileEntry
                    ref={phoneLocation}
                    id="phone"
                    label="Mobile Number"
                    variant="outlined"
                    phoneNumber={state.phoneNumber.value}
                    passThroughError={state.phoneNumber.error}
                    error={phoneError}
                    touched={phoneTouched}
                    value={phoneValue}
                    sx={{
                        width: '97%',
                        marginTop: theme.spacing(2),
                        marginBottom: theme.spacing(2),
                    }}
                />

                <Box ref={addressLocation}>
                    <LocationSearchInput
                        id="address"
                        onSelect={handleSelect}
                        onChange={changingAddress}
                        error={state.address.error}
                        searchType="address"
                        initialAddress={state.address.value.address}
                        sx={{
                            width: '97%',
                            marginTop: theme.spacing(2),
                            marginBottom: theme.spacing(2),
                        }}
                    />
                </Box>

                <LimitedTextField
                    label="bio"
                    data-cy="bio"
                    error={state.bio.error}
                    value={state.bio.value}
                    updateField={updateField}
                    width="97%"
                    textLength={500}
                />

                <BookingButton
                    id="profileSave"
                    data-cy="save-profile"
                    size="large"
                    color="primary"
                    onClick={event => {
                        handleProfileSubmit(event);
                    }}
                    loading={loading}
                    loadingPosition="start"
                    startIcon={<SaveIcon />}
                    variant="outlined"
                    disabled={saveDisabled}
                >
                    Save
                </BookingButton>

                {/* <Button
                    id="profileSave"
                    variant="contained"
                    color="primary"
                    size="large"
                    onClick={event => {
                        handleProfileSubmit(event);
                    }}
                >
                    Save
                </Button> */}
            </Grid>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="Modal-Profile-Image"
                aria-describedby="Open-Modal-For-Upload"
            >
                <InputImageModal
                    parentCallback={callback}
                    text="Profile Image"
                />
            </Modal>
        </Grid>
    );
};

export default General;
